"use client"
import { useBaseNavLinks } from "config/navigation"
import OrgGroupSelectorBox from "features/account/accountSelection/OrgGroupSelectorBox"
import { useHypertune } from "lib/feature-flags/generated/hypertune.react"
import { useOrgGroups } from "services"

import { useGlobalDrawers } from "../../../components/legacyComponents/layout/state/useGlobalDrawers"
import NavLinkItem from "../components/NavLinkItem"

import type React from "react"

export const BaseNavigationLinks: React.FC = () => {
    const { toggleAlertsDrawer } = useGlobalDrawers()
    const { baseNavLinks } = useBaseNavLinks()
    const { groups } = useOrgGroups()
    const orgGroupSelectorPosition = useHypertune().orgGroupSelectorPosition({
        fallback: "bottomNav"
    })
    return (
        <section
            className='relative flex flex-col items-start justify-start w-full dark:text-gray-200'
            id='base-nav-links'
        >
            {orgGroupSelectorPosition === "topNav" && groups?.length > 1 && (
                <div className='w-full mb-3'>
                    <OrgGroupSelectorBox />
                </div>
            )}

            {baseNavLinks.map((application, i) => (
                <NavLinkItem
                    item={{
                        ...application,
                        onClick: () => {
                            if (application.label === "Alerts") {
                                toggleAlertsDrawer(true)
                            }
                        }
                    }}
                    key={`${application.application}_${application.path}`}
                />
            ))}
        </section>
    )
}

export default BaseNavigationLinks
